import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SingleFormComponent} from '..';

@Component({
  selector: 'gc-field-single-form',
  templateUrl: './field-single-form.component.html',
  styleUrls: ['./field-single-form.component.css']
})
export class FieldSingleFormComponent implements OnInit {

  constructor() { }

  f: SingleFormComponent = null;
  @Input()
  get form(): any { return this.f; }
  set form(f: any) {
    this.f = f;
  }

  @Input() name: string;
  @Output()
  changed: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {

  }

  onChange(value): void {
    this.changed.emit(value);
  }

}
